import axios from 'axios'
import store from '@/store'
export default () => {
  return axios.create({
   baseURL: `https://test-arrendamiento.complementservices.com/api/`,
   //baseURL: `http://localhost:7980/api/`,
    headers: {
      Authorization: `Bearer ${store.state.token}`
    }
  })
}
